import { render } from "./menuBtn.vue?vue&type=template&id=1dfe57d8&scoped=true"
import script from "./menuBtn.vue?vue&type=script&lang=js"
export * from "./menuBtn.vue?vue&type=script&lang=js"

import "./menuBtn.vue?vue&type=style&index=0&id=1dfe57d8&scoped=true&lang=css"

import exportComponent from "/Users/mathieu/conductor/workspaces/miakapp-v3/lima-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dfe57d8"]])

export default __exports__